/**
 * Puts a macOS popover's pin (styles/mac-popover.scss) right under the middle of its nav item's label (owner
 * 2026-10-12): sets --caret-right on the popover, the distance from its right edge to the middle of the label's
 * text (the text itself, not the icon beside it).
 */
export function placeCaret( popover: HTMLElement | null, label: HTMLElement | null ): void {
  if ( !popover || !label || typeof document === 'undefined' ) return;
  const text = lastTextNode( label );
  let middle: number;
  if ( text ) {
    const range = document.createRange();
    range.selectNodeContents( text );
    const box = range.getBoundingClientRect();
    middle = ( box.left + box.right ) / 2;
  } else {
    const box = label.getBoundingClientRect();
    middle = ( box.left + box.right ) / 2;
  }
  const right = popover.getBoundingClientRect().right - middle;
  popover.style.setProperty( '--caret-right', `${ Math.round( right ) }px` );
}

function lastTextNode( element: Node ): Text | null {
  for ( let i = element.childNodes.length - 1; i >= 0; i-- ) {
    const child = element.childNodes[ i ];
    if ( child.nodeType === Node.TEXT_NODE && child.textContent?.trim() ) return child as Text;
    const inner = lastTextNode( child );
    if ( inner ) return inner;
  }
  return null;
}
